import { createSlice } from '@reduxjs/toolkit'
import name from './name'

// Store
export const campaign = createSlice({
  name,
  initialState: {
    list: [],
    total: 0
  },
  reducers: {
    getCampaignList: (state, { payload }) => {
      state.list = payload.campaigns
      state.total = payload.total
      state.lastKey = payload.lastKey
    },
    addCampaignList: (state, { payload }) => {
      state.list = state.list.concat(payload.campaigns)
      state.total = payload.total
      state.lastKey = payload.lastKey
    },
    updateCampaignIsActiveInList: (state, { payload: { pk, isActive } }) => {
      state.list.find(t => t.pk === pk).isActive = isActive
    },
    resetCampaignList: (state) => {
      state.list = []
      state.total = 0
    }
  }
})

export const { getCampaignList, addCampaignList, updateCampaignIsActiveInList, resetCampaignList } = campaign.actions

export default campaign.reducer
